import React, { useState, useEffect } from "react";
import defaultUserImage from "../../assets/DefaultImage/user1.jpeg"; // Par défaut pour les utilisateurs
import defaultCandidateImage from "../../assets/DefaultImage/userblack.jpg"
import defaultOtherImage from "../../assets/DefaultImage/defaultImage.jpg"
import defaultRequestImage from "../../assets/DefaultImage/Search Projects __ Photos, videos, logos, illustrations and branding.gif"
import defaultTrainingImage from "../../assets/Illustrations/Female student holding big pencil vector illustration.jpeg"
import logoBlanckImage from "../../assets/DefaultImage/c62d863f467a79a61807c82e03037867.png"

const ImageWithFallback = ({ src, alt = "", className, defaultType = "other" }) => {
  // Logique pour sélectionner l'image par défaut selon le type
  const getDefaultImage = () => {
    switch (defaultType) {
      case "user":
        return defaultUserImage;//userblack.jpg
        case "candidate":
          return defaultCandidateImage;
      case "request":
        return defaultRequestImage;
      case "training":
          return defaultTrainingImage;
          case "logo":
            return logoBlanckImage;
      default:
        return defaultOtherImage;
    }
  }

  const [imgSrc, setImgSrc] = useState(src || getDefaultImage());

  const handleError = () => {
    setImgSrc(getDefaultImage());
  };

  useEffect(() => {
    // Si src change, mettre à jour l'image
    setImgSrc(src || getDefaultImage());
  }, [src, defaultType]);

  return (
    <img
      src={imgSrc}
      alt={alt || "default image"}
      onError={handleError}
      className={className}
    />
  );
};

export default ImageWithFallback